export default __webpack_public_path__ + "static/media/eye.5afc0772.svg";